export const OPEN_PROMO_MODAL = 'OPEN_PROMO_MODAL';
export const CLOSE_PROMO_MODAL = 'CLOSE_PROMO_MODAL';
